// Modificar DataSharingService
import {Injectable} from '@angular/core';
import {Subject, BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {

  public currentMoneySubject:       Subject<string>   = new Subject<string>();
  public currentTaxSubject:         Subject<number>   = new Subject<number>();
  public alert_new_order_sound:     Subject<boolean>  = new Subject<boolean>();
  public is_super:                  Subject<boolean>  = new Subject<boolean>();
  public uid:                       Subject<string>   = new Subject<string>();
  public appName:                   Subject<string>   = new Subject<string>();
  public primary_color:             Subject<string>   = new Subject<string>();
  public secondary_color:           Subject<string>   = new Subject<string>();

  public show_supplier:             Subject<boolean>   = new Subject<boolean>();
  public isRetail:                  Subject<boolean>   = new Subject<boolean>();
  public isProjectService:          Subject<boolean>   = new Subject<boolean>();
  public isRestaurant:              Subject<boolean>   = new Subject<boolean>();
  public isPointOfSale:             Subject<boolean>   = new Subject<boolean>();
  public hasTablesReservation:      Subject<boolean>   = new Subject<boolean>();
  public hasNumberOfCustomers:      Subject<boolean>   = new Subject<boolean>();
  public isAdminMemberShip:         Subject<boolean>   = new Subject<boolean>();
  public isOnlyView:                Subject<boolean>   = new Subject<boolean>();
  public unique_tax:                Subject<boolean>   = new Subject<boolean>();
  public transactions:              Subject<any>       = new Subject<any>();

  // ✅ NUEVO: Compartir las órdenes en tiempo real
  private ordersSubject = new BehaviorSubject<any[]>([]);
  public orders$ = this.ordersSubject.asObservable();

  constructor() { }

  // ✅ Método para actualizar las órdenes desde Navbar
  updateOrders(orders: any[]) {
    this.ordersSubject.next(orders);
  }

  // ✅ Método para notificar nuevas órdenes
  private newOrdersSubject = new Subject<void>();
  public newOrders$ = this.newOrdersSubject.asObservable();

  notifyNewOrders() {
    this.newOrdersSubject.next();
  }
}